import { render, staticRenderFns } from "./TeamInvoiceAging.vue?vue&type=template&id=3b9412e6&scoped=true&"
import script from "./TeamInvoiceAging.vue?vue&type=script&lang=js&"
export * from "./TeamInvoiceAging.vue?vue&type=script&lang=js&"
import style0 from "./TeamInvoiceAging.vue?vue&type=style&index=0&id=3b9412e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9412e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VFadeTransition,VRow})
